export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9227.c9b94368.jpg";